// Load jQuery
import $ from 'jquery';
window.$ = window.jQuery = $;

// Load BS
require('bootstrap');

// missing forEach on NodeList for IE11
if (window.NodeList && !NodeList.prototype.forEach) {
  NodeList.prototype.forEach = Array.prototype.forEach;
}

//Load Libraries
require('flatpickr/dist/flatpickr.min');
// require('magnific-popup/dist/jquery.magnific-popup.min');
// require('objectFitPolyfill/dist/objectFitPolyfill.min');
require('select2/dist/js/select2.full.min');
require('chart.js/dist/Chart');
require('datatables/media/js/jquery.dataTables.min');
require('./modules/typeahead.jquery');

// Load Modules
require('./modules/accordion');
// require('./modules/animatein');
// require('./modules/bannerVideo');
require('./modules/formInputs');
// require('./modules/localVideoBlock');
require('./modules/menu');
require('./modules/modal');
require('./modules/sliders');
// require('./modules/scrollTo');
// require('./modules/searchToggle');
// require('./modules/shareSocial');
// require('./modules/sideMenu');
require('./modules/tabs');
require('./modules/dropzone');
require('./modules/charts');
require('./modules/alert');

$(function() {
  $('.entity_selector,.language_selector').change(function () {
      document.location = $(this).val();
  });

  $('body').css('padding-top', $('.header').outerHeight());
});

$.ajaxSetup({
  headers: {
    'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
  }
});
